<app-header *ngIf="showHeaderFooter"></app-header>

<div class="auth-language-switcher" *ngIf="!showHeaderFooter">
  <mat-icon>language</mat-icon>
  <mat-select
    class="auth-language-select"
    [value]="selectedLanguageCode"
    (selectionChange)="changeLanguage($any($event.value))"
    [attr.aria-label]="'common.language' | translate"
    panelClass="auth-language-panel"
    panelWidth="auto"
    [disableOptionCentering]="true"
  >
    <mat-select-trigger>
      <span class="auth-language-trigger">
        <img
          [src]="selectedLanguage.flagUrl"
          class="auth-flag-icon"
          [alt]="selectedLanguage.labelKey | translate"
        />
        <span class="auth-language-label">{{ selectedLanguage.labelKey | translate }}</span>
      </span>
    </mat-select-trigger>

    <mat-option class="auth-language-option auth-language-option-hidden" [value]="selectedLanguageCode">
      <span class="auth-language-option-content">
        <img
          [src]="selectedLanguage.flagUrl"
          class="auth-flag-icon"
          [alt]="selectedLanguage.labelKey | translate"
        />
        <span class="auth-language-option-label">{{ selectedLanguage.labelKey | translate }}</span>
      </span>
    </mat-option>

    @for (language of languages; track language.code) {
      @if (language.code !== selectedLanguageCode) {
        <mat-option class="auth-language-option" [value]="language.code">
          <span class="auth-language-option-content">
            <img
              [src]="language.flagUrl"
              class="auth-flag-icon"
              [alt]="language.labelKey | translate"
            />
            <span class="auth-language-option-label">{{ language.labelKey | translate }}</span>
          </span>
        </mat-option>
      }
    }
  </mat-select>
</div>

<main>
  <router-outlet></router-outlet>
</main>
<app-footer *ngIf="showHeaderFooter"></app-footer>

